import React from 'react';
import { ILegalPhaseTemplateFullObject } from '../Interfaces/ILegalPhaseTemplate';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { LegalPhaseTemplateRow } from './LegalPhaseTemplateRow';

interface IProps {
  legalPhaseTemplateArray: ILegalPhaseTemplateFullObject[];
  setLegalPhaseTemplateArray: Function;
  selectedRequirementsIds: number[];
  setSelectedRequirementsIds: Function;
}

export const LegalPhaseTemplateTable: React.FC<IProps> = ({
  legalPhaseTemplateArray,
  setLegalPhaseTemplateArray,
  selectedRequirementsIds,
  setSelectedRequirementsIds,
}) => {
  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={'5%'}></TableCell>
            <TableCell width={'30%'}>Bezeichnung</TableCell>
            <TableCell width={'20%'}>Vorgänger</TableCell>
            <TableCell width={'15%'}></TableCell>
            <TableCell width={'5%'}>Interne Maßnahme</TableCell>
            <TableCell width={'5%'}>Upload Mandanten</TableCell>
            <TableCell width={'5%'}>Upload Mitarbeiter</TableCell>
            <TableCell width={'5%'}>
              Auto. <span style={{ whiteSpace: 'nowrap' }}>E-Mail</span>
            </TableCell>
            <TableCell width={'10%'}>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {legalPhaseTemplateArray
            .sort((a, b) => (a.Position < b.Position ? -1 : 1))
            .map(x => (
              <LegalPhaseTemplateRow
                key={`idLegalPhaseTemplate-${x.idLegalPhaseTemplate}`}
                currentPhase={x}
                legalPhaseTemplateArray={legalPhaseTemplateArray}
                setLegalPhaseTemplateArray={setLegalPhaseTemplateArray}
                selectedRequirementsIds={selectedRequirementsIds}
                setSelectedRequirementsIds={setSelectedRequirementsIds}
              />
            ))}
        </TableBody>
      </Table>
    </>
  );
};
